import { tokens } from "@fluentui/react-components";

/**
 * 차트 시리즈 색. 색은 상태와 구분에만 쓴다(장식 팔레트 금지).
 * - actual: 실제 값(브랜드) · plan: 계획/기준선(중립, 점선) · reference: 판단 기준선(1.0, 100% 등)
 * - good/warn/bad: 상태 · empty: 미정·없음 · 연한 톤(*Soft)은 교차 강조 때 나머지를 물리는 데 쓴다.
 * 모두 Fluent 토큰(CSS 변수)이라 다크 모드에서 그대로 바뀐다.
 */
export const SERIES = {
  // Foreground1은 테마에서 라이트 #0A7AFF / 다크 #5BA3FF로 잡혀 있어 두 모드 모두 배경 대비가 충분하다.
  actual: tokens.colorBrandForeground1,
  actualSoft: tokens.colorBrandBackground2,
  plan: tokens.colorNeutralForeground3,
  reference: tokens.colorNeutralStroke1,
  good: tokens.colorPaletteGreenBackground3,
  goodSoft: tokens.colorPaletteGreenBackground2,
  warn: tokens.colorPaletteDarkOrangeBackground3,
  warnSoft: tokens.colorPaletteDarkOrangeBackground2,
  bad: tokens.colorPaletteRedBackground3,
  badSoft: tokens.colorPaletteRedBackground2,
  info: tokens.colorPaletteBlueBackground2,
  empty: tokens.colorNeutralStroke1,
} as const;

export type SeriesTone = "actual" | "good" | "warn" | "bad" | "empty";

const SOFT: Record<SeriesTone, string> = {
  actual: SERIES.actualSoft,
  good: SERIES.goodSoft,
  warn: SERIES.warnSoft,
  bad: SERIES.badSoft,
  empty: tokens.colorNeutralStroke2,
};

/** 강조 중이 아닌 항목은 같은 색상의 연한 톤으로 물린다. */
export function toneColor(tone: SeriesTone, dimmed = false): string {
  return dimmed ? SOFT[tone] : SERIES[tone];
}
